// Unified attendance color palette + labels — used by student, teacher and admin views.
//
// Semantic mapping (Spanish):
//   present               → Presente             (verde)
//   justified             → Ausencia justificada (naranja)
//   unjustified /
//   unjustified_consumed /
//   absent                → Ausente injustificada (rojo)
//   teacher_cancelled     → Clase cancelada       (gris oscuro)
//   ""(future, no record) → Pendiente por cubrir  (gris claro + borde negro)

export const ATTENDANCE_STATUSES = [
  "present",
  "justified",
  "unjustified",
  "unjustified_consumed",
  "absent",
  "teacher_cancelled",
  "not_counted",
  "removed",
];

/** Chip / pill styling for a single date. Returns tailwind classes. */
export function attendanceChipClass(status) {
  switch (status) {
    case "paused":
      // Fecha dentro de una pausa: no consume el ciclo ni se puede marcar.
      return "bg-slate-200 text-slate-500 border-slate-300 border-dashed";
    case "present":
      return "bg-emerald-200 text-emerald-900 border-emerald-500";
    case "justified":
      return "bg-orange-200 text-orange-900 border-orange-500";
    case "unjustified":
    case "unjustified_consumed":
    case "absent":
      return "bg-red-200 text-red-900 border-red-500";
    case "teacher_cancelled":
      return "bg-slate-500 text-white border-slate-700";
    case "not_counted":
      return "bg-indigo-100 text-indigo-900 border-indigo-500 border-dashed";
    case "removed":
      return "bg-white text-slate-400 border-slate-300 border-dashed line-through";
    default:
      // Pendiente por cubrir (future or no record)
      return "bg-slate-100 text-slate-700 border-slate-900";
  }
}

/** Small colored dot for legends / status indicators. */
export function attendanceDotClass(status) {
  switch (status) {
    case "paused":
      return "bg-slate-300 border border-dashed border-slate-400";
    case "present":
      return "bg-emerald-500";
    case "justified":
      return "bg-orange-500";
    case "unjustified":
    case "unjustified_consumed":
    case "absent":
      return "bg-red-500";
    case "teacher_cancelled":
      return "bg-slate-600";
    case "not_counted":
      return "bg-indigo-400";
    case "removed":
      return "bg-white border border-dashed border-slate-400";
    default:
      return "bg-slate-200 border border-slate-900";
  }
}

/** Localized label for a status (falls back to the i18n key). */
export function attendanceLabel(status, t) {
  const key = status || "pending_to_cover";
  const map = {
    present: "present",
    justified: "justified",
    unjustified: "unjustified",
    unjustified_consumed: "unjustified_consumed",
    absent: "unjustified",
    teacher_cancelled: "teacher_cancelled",
    not_counted: "not_counted",
    removed: "removed",
    pending_to_cover: "upcoming",
  };
  return t(map[key] || key);
}
